import FormationCard from "../../Components/FormationCard";
import { CircularProgress, Grid } from '@mui/material'
import api from "../../Api/api";
import { useEffect, useState } from "react";
import BoxText from "../../Components/BoxText";
import Box from '@mui/material/Box';
import BoutiqueCard from "../../Components/BoutiqueCard";

export const CardContainer = props => {

    const { typeProduit } = props // 'atelier' ou 'boutique'
    const [produits, setProduits] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchProduits = async () => {
            const listProduits = await api.getAllProduitByType(typeProduit);
            let filteredListProduits
            if (typeProduit === 'atelier') {
                filteredListProduits = listProduits
                    .filter((el) => {
                        if (!el.date) return true; 
                        const [datePart, timePart] = el.date.split(' ');
                        const [day, month, year] = datePart.split('/').map(Number);
                        let [hour, minute] = timePart ? timePart.split(':').map(Number) : [0, 0];
                        const dateAtelier = new Date(year, month - 1, day, hour='00', minute='00');
                        const today = new Date();
                        return (dateAtelier > today);
                    })
                    .sort((a, b) => {
                        const getDate = (el) => {
                            if (!el.date) return false;
                            const [datePart, timePart] = el.date.split(' ');
                            const [day, month, year] = datePart.split('/').map(Number);
                            let [hour, minute] = timePart ? timePart.split(':').map(Number) : [0, 0];
                            return new Date(year, month - 1, day, hour, minute);
                        };
                        return getDate(a) - getDate(b);
                    });
            } else {
                filteredListProduits = listProduits
                    .sort((a, b) => (b.totalUnits - b.bookedUnits) - (a.totalUnits - a.bookedUnits));
            }
            setProduits(filteredListProduits);
            setIsLoading(false);
        };
        fetchProduits();
    }, []);

    return (
        <Box sx={{ backgroundColor: 'transparent', position: 'relative', zIndex: 1}}>
        {isLoading && <CircularProgress color="inherit"/>}
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            align='center'
        >
            {isLoading ? null : (
                produits.length ? 
                    produits.map((el, index) => (
                        <Grid
                        key={index}
                        item
                        sx={{
                            padding: 1,
                            rowSpacing: 2,
                            columnSpacing: 2,
                            align: 'center',
                            direction:"row",
                            justifyContent:"center",
                            alignItems: "center",
                        }}
                        xs="12" md="6" lg={typeProduit === 'atelier' ? 6 : 5}>
                            { typeProduit === 'atelier' ?
                                <FormationCard product={{...el}} />
                            :
                                <BoutiqueCard product={{...el}} />
                            }   
                        </Grid>
                    ))
                    : <Grid item xs={12} sx={{ textAlign: 'center', alignItems: 'center' }}>
                        { typeProduit === 'atelier' ?
                            <BoxText 
                                title='Aucun atelier'
                                body="Aucun atelier n'est disponible pour le moment, revenez plus tard pour voir nos prochains ateliers et n'hésitez pas à nous contacter pour toute demande"
                                link='/contact'
                                textButton="Nous contacter"
                            />
                        :
                            <BoxText
                                title={"Bientôt disponible"}
                                body={"Aucun produit n'est disponible pour le moment, revenez plus tard pour voir nos prochains produits et n'hésitez pas à essayer nos ateliers en attendant !"}
                                link={"/ateliers"}
                                textButton={"Voir les ateliers"}
                            />
                        }
                    </Grid>
            )}
        </Grid>
        </Box>
    );
}

export default CardContainer;